module.exports = "/assets/56506fb299f56591bf8363fb4550c9c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/MK.png
// module id = 2741
// module chunks = 0